import React from "react";

export default class BookingFlowBrandingFooter extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className='branding-footer'>
        <strong>
          <a href={this.props.property.website_url} target="_blank" >
            {this.props.property.name}
            </a>
        </strong>
        <div className='branding-footer-text contact-info'>
            {`${this.props.property.email} • ${this.props.property.main_telephone}`}
        </div>
        <div className='branding-footer-text'>
            {`${this.props.property.address_1} • ${this.props.property.city}, ${this.props.property.state}`}
        </div>
      </div>
    );
  }

}